import { createActionName } from "../../../utility"

export const reducerName = "journeys"

export const JOURNEYS = createActionName(reducerName, "JOURNEYS")
export const JOURNEY = createActionName(reducerName, "JOURNEY")
